// Homepage background videos have no visible playback controls.
(() => {
  function mount(root = document) {
    root.querySelectorAll('.slideshow__slide video').forEach(video => {
      if (video.dataset.cbxPlayback) return;
      video.dataset.cbxPlayback = 'true';
      const hideNative = () => { if (video.controls) video.controls = false; };
      hideNative();
      // The theme/deferred loader may restore controls after autoplay fails.
      const observer = new MutationObserver(hideNative);
      observer.observe(video, {attributes:true, attributeFilter:['controls']});
      const unload = event => {
        if (!event.target.contains(video)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
